import React from "react"
import { connect } from "react-redux"
import { showNotificationWithTimeout } from "../../_actions/adminAlertActionCreator"
import PaypalExpressBtn from "react-paypal-express-checkout"

function OnlineButton({
  orderData,
  grandTotal,
  setOnlinePaymentDetails,
  showAlert,
  method
}) {
  switch (method.gateway_code) {
    case "PAYP":
      const onSuccess = async payment => {
        // Congratulation, it came here means everything's fine!
        // console.log("The payment was succeeded!", payment)
        //Push new data to api
        showAlert({
          message: "Payment received.",
          type: "success",
          consumer: "checkout"
        })
        setOnlinePaymentDetails &&
          setOnlinePaymentDetails(payment, method.gateway_code, method.id)
        // You can bind the "payment" object's value to your state or props or whatever here, please see below for sample returned data
      }

      const onCancel = data => {
        // User pressed "cancel" or close Paypal's popup!
        // console.log("The payment was cancelled!", data)
        // You can bind the "data" object's value to your state or props or whatever here, please see below for sample returned data
      }

      const onError = err => {
        // The main Paypal's script cannot be loaded or somethings block the loading of that script!
        console.log("Error!", err)
        showAlert({
          message: "Something went wrong.",
          type: "error",
          consumer: "checkout"
        })
        // Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
        // => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
      }

      // you can set here to 'production' for production
      let env =
        process.env.REACT_APP_ENV === "production" ? "production" : "sandbox"

      let currency = orderData.currency // or you can set this value from your props or state
      let total = parseFloat(grandTotal).toFixed(2) // same as above, this is the total amount (based on currency) to be paid by using Paypal express checkout
      // Document on Paypal's currency code: https://developer.paypal.com/docs/classic/api/currency_codes/

      const client = {
        sandbox: method.api_key,
        production: method.api_key
      }
      return (
        <div className="payp">
          <PaypalExpressBtn
            env={env}
            client={client}
            currency={currency}
            total={total}
            onSuccess={onSuccess}
            onCancel={onCancel}
            onError={onError}
          />
        </div>
      )

    case "PAYM":
      function handlePaymayaCheckout() {
        setOnlinePaymentDetails &&
          setOnlinePaymentDetails({}, method.gateway_code, method.id)
      }

      return (
        <>
          <button
            key={`${method.id}-mcard`}
            type="button"
            onClick={handlePaymayaCheckout}
            value={`${method.id}-mcard`}
            className={`method-button mcard`}
          >
            Mastercard
          </button>
          <button
            key={`${method.id}-visa`}
            type="button"
            onClick={handlePaymayaCheckout}
            value={`${method.id}-visa`}
            className={`method-button visa`}
          >
            Visa
          </button>
          <button
            key={`${method.id}-jcb`}
            type="button"
            onClick={handlePaymayaCheckout}
            value={`${method.id}-jcb`}
            className={`method-button jcb`}
          >
            JCB
          </button>
        </>
      )

    case "COINS":
      function handleCoinsCheckout() {
        setOnlinePaymentDetails &&
          setOnlinePaymentDetails({}, method.gateway_code, method.id)
      }

      return (
        <button
          key={method.id}
          type="button"
          onClick={handleCoinsCheckout}
          value={method.id}
          className={`method-button ${method.gateway_code &&
            method.gateway_code.toLowerCase()}`}
        >
          {method.gateway_name}
        </button>
      )

    default:
      return null
  }
}

const mapDispatchToProps = dispatch => ({
  showAlert: alert => {
    showNotificationWithTimeout(dispatch, alert)
  }
})

export default connect(
  null,
  mapDispatchToProps
)(OnlineButton)
